'use strict';

// ----------------------------------------
// Imports
// ----------------------------------------

import '../_vendors/jquery.cssmap.min';

// ----------------------------------------
// Private
// ----------------------------------------

let $map = $('#map-poland');

// ----------------------------------------
// Public
// ----------------------------------------

function initCssMap () {
	$map.CSSMap({
		'size': 320,
		mapStyle: 'custom',
		tooltip: 'sticky',
		formSupport: {
			enable: true,
			inputId: '#regions',
			value: 'slug'
		}
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

export {initCssMap};



// WEBPACK FOOTER //
// ./src/js/_modules/css-map.js